import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";

interface mutateProps {
  communityId: string;
  module: string;
  data: FieldValues
}

const mutateAddPropertyCategory = async ({ data, communityId, module }: mutateProps) => {
  return await axiosAuth.post(`v1/${module}/community/${communityId}`, data);
};

const useAddPropertyCategoryMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddPropertyCategory,
    ...queryParams,
  });

export default useAddPropertyCategoryMutation;
